<template>
    <ContentOrLoading style="min-height: 200px;">
        <b-row v-if="! loading">        
            <b-col md="6" sm="12">
                <b-card>
                    <h3>Total de abonados agrupados por precio.</h3>
                    <b-table striped hover :items="ocupacionPrecios"/>
                </b-card>
            </b-col>
            <b-col md="6" sm="12">
                <b-card>
                    <h3>Gráfica de abonos agrupados por precios.</h3>
                    <GChart
                        type="PieChart"
                        :data="chartData"
                        :options="{
                            height: 400,
                            chartArea:{width:'100%'}
                        }"
                    />
                </b-card>
            </b-col>    
        </b-row>
    </ContentOrLoading>
</template>

<script>
    export default {
        props: ['lista_id'],
        data() {
            return {
                loading: true,
                ocupacionPrecios: null
            }
        },
        created() {
            this.getInformeOcupacionPrecios();
        },
        computed: {
            chartData() {
                let data = [
                    ['precio', 'abonos']
                ];

                if(this.ocupacionPrecios) {
                    let array_prices = this.ocupacionPrecios.slice();
                    array_prices.pop();

                    array_prices.forEach(precio => {
                        data.push([
                            precio.precio, precio.abonos
                        ]);
                    });
                }            

                return data;
            }
        },
        methods: {
            getInformeOcupacionPrecios() {
                const params = {
                    filters: {},
                    lista_id: this.lista_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonos.desglose-ventas.ocupacion-precios'), params).then(res => {
                    this.ocupacionPrecios = res.data.data;
                }).finally(() => this.loading = false);
            },
        }
    }
</script>